import React, { useState } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { Flex } from "@chakra-ui/react";
import LaunchdeckModal from '../../../global/components/helper-components/components/LaunchdeckModal';
import AddNewOrgUserForm from '../add-member/AddNewOrgUserForm';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import SubscriptionNudgeModal from '../../../marketing/components/SubscriptionNudgeModal';
import ProAccountNeededIcon from '../../../global/components/product-marketing/ProAccountNeededIcon';


function AddOrgMemberModule({ 
	orgIdToken,
	paidFeatureAccess
}) {
	
	const [showEditOrgMemberModal, setShowEditOrgMemberModal] = useState(false);
	const [showSubscriptionNudge, setShowSubscriptionNudge] = useState(false);
	
	return (
		<React.Fragment>
			<Flex w='100%' justify='flex-end'>
					<Flex direction='column' justify='center' alignItems='center'>
						<Flex justify={['center', 'flex-end', 'flex-end', 'flex-end']} w='100%'>
							<LaunchdeckButton bg={paidFeatureAccess ? 'brand.500' : 'gray.500'} color={'white'} gap={2} onClick={paidFeatureAccess ? 
							() => setShowEditOrgMemberModal(true)
							:
								()=> {	
									setShowSubscriptionNudge(true)
								} 
								
								} 
								 >
									<Flex align='center' gap={2}>
									Add User <ProAccountNeededIcon />
									</Flex>

								</LaunchdeckButton>
						</Flex>
					</Flex>
			</Flex>

			<LaunchdeckModal
				title='Add Team Member'
				handleCloseModal={() => setShowEditOrgMemberModal(false)}
				showModal={showEditOrgMemberModal}
			>
				<AddNewOrgUserForm
					orgIdToken={orgIdToken} 
					handleCloseModal={() => setShowEditOrgMemberModal(false)} 
					role={''} // No role defined for brand new user yet
				/>
			</LaunchdeckModal>

{/* Hi five image? */}
			{showSubscriptionNudge && <SubscriptionNudgeModal 
			titleText="⛳ Add your coworkers to your Organization team"
			copyText={`Upgrade & collaborate with your team today!`}
			handleCloseModal={()=>setShowSubscriptionNudge(false)}/>}

		</React.Fragment>
	)

}


function mapStateToProps(state) {
	return {
		paidFeatureAccess: state.userPrivileges.results.paidFeatureAccess,
	};
}

export default withRouter(connect(mapStateToProps, null)(AddOrgMemberModule));